<template>
  <v-dialog v-model="open" max-width="300">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>

    <v-card class="px-3">
      <v-card-title>Create new campaign</v-card-title>

      <v-text-field v-model="campaignName" placeholder="tilte"></v-text-field>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose(false)">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="onClose(true)">
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreateCampaignModal',
  data() {
    return {
      open: false,
      campaignName: ''
    };
  },
  methods: {
    onClose(confirm) {
      if (confirm) {
        this.$emit('confirm', this.campaignName);
      }

      this.campaignName = '';
      this.open = false;
    }
  }
};
</script>
